import Landing from "@tw/customer-identity-cra/lib/login/landing-master-nextjs";
import PageWrapper from "../../../wrappers/page-wrapper";

Landing.domainName = "customer-identity";

export default PageWrapper(Landing);